/**
 * @owner @Appboy/core-objects
 *
 * @fileoverview GET handler for the "/apps/catalogs" endpoint
 */
import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogs } from "./constants";
import type { AppsCatalogsResult, GetAppsCatalogsParams } from "@dashboardApi/apis/appsCatalogs/types";

export const getAppsCatalogs = reactQueryFetcherAdapter(
  appsCatalogs,
  (signal: AbortSignal, params: GetAppsCatalogsParams): Promise<AppsCatalogsResult> => {
    return fetch(`/apps/catalogs`, "GET", params, { signal });
  }
);
